import { TasksListView } from "./TasksListView";

export function MyTasksPage() {
  return <TasksListView title="My Tasks" scope="mine" />;
}
